import { render, staticRenderFns } from "./WhoAmI_View.vue?vue&type=template&id=39ec3eac&scoped=true&"
import script from "./WhoAmI_View.vue?vue&type=script&lang=js&"
export * from "./WhoAmI_View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec3eac",
  null
  
)

export default component.exports